import { render, staticRenderFns } from "./presens-av-starka-verb.vue?vue&type=template&id=41069c61&scoped=true"
import script from "./presens-av-starka-verb.vue?vue&type=script&lang=js"
export * from "./presens-av-starka-verb.vue?vue&type=script&lang=js"
import style0 from "./presens-av-starka-verb.vue?vue&type=style&index=0&id=41069c61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41069c61",
  null
  
)

export default component.exports